import styled from "@emotion/styled";

import { media } from "@styles";

export const Wrapper = styled.div``;

export const Row = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  align-items: center;
  height: 5rem;
  cursor: pointer;

  border-bottom: 1px solid ${(props) => props.theme.colors.tableDivider};
`;

export const HeaderRow = styled(Row)`
  color: ${(props) => props.theme.colors.lightFont};
  cursor: default;
`;

export const IndexNumber = styled.div`
  width: 10%;
  ${media.smallScreen`
     width: 30%;
  `}
`;
export const ProductsOrdered = styled.div`
  width: 25%;
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: center;
`;
export const ThumbnailWrapper = styled.div`
  position: relative;
  height: 70px;
  width: 40px;
  display: inline-block;
`;
export const DateOfOrder = styled.div`
  width: 25%;
`;
export const Value = styled.div`
  width: 10%;
`;
export const Status = styled.div`
  width: 25%;
  ${media.smallScreen`
     width: 50%;
  `}
`;
